<template>
  <div class="hackerrank row-test">
    <v-row justify="center">
      <v-col cols="7">
        <vacancy-title />
      </v-col>
    </v-row>

    <div class="hackerrank__body">
      <v-row justify="center">
        <v-col cols="7">
          <div class="hackerrank__header">HackerRank</div>

          <div class="hackerrank__description">
            {{
              $tr('integrations.hackerrank.vacancy-description', {
                integrationName: 'HackerRank'
              })
            }}
          </div>

          <switcher
            class="hackerrank__switcher"
            :value="isVacancyHackerrankConnected"
            :disabled="isConnectionLoading"
            :text="$tr('integrations.hackerrank.toggle-step')"
            @input="toggleHackerrankToVacancy(Number(vcvVacancyId))"
          />

          <div v-if="isVacancyHackerrankConnected" class="hackerrank__tests">
            <vpreloader v-if="isConnectionLoading" :width="3" :size="44" />

            <div v-for="(item, index) in testsCount" v-else :key="item.id" class="hackerrank__test">
              <div class="hackerrank__test-header">{{ `${index + 1} ${$tr('common.test')}` }}</div>

              <div class="hackerrank__test-select-wrapper">
                <multiselect
                  v-model="selectedTests[index]"
                  class="hackerrank__test-select"
                  :options="optionsForSelect"
                  :show-labels="false"
                  :allow-empty="false"
                  :placeholder="$tr('common.choose-test')"
                  searchable
                  track-by="id"
                  label="name"
                />

                <vbutton
                  :disabled="selectedTests.length <= 1"
                  type="icon"
                  icon="icon-bin"
                  color="grey"
                  @click="removeItemFromTests(index)"
                />
              </div>
            </div>
          </div>

          <div v-if="isVacancyHackerrankConnected" class="hackerrank__actions">
            <vbutton
              :disabled="
                testsCount >= getHackerrankTestsForSelect.length ||
                testsCount > selectedTests.length
              "
              :text="$tr('common.add-test')"
              icon="icon-plus"
              color="grey"
              @click="testsCount += 1"
            />

            <vbutton
              :disabled="!isVacancyHackerrankConnected"
              :loading="isConnectionLoading"
              :text="$tr('actions.save')"
              color="green"
              @click="
                saveHackerrankTests({
                  vacancyId: Number(vcvVacancyId),
                  tests: selectedTestsForSave
                })
              "
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import { differenceBy } from 'lodash';
  import VacancyTitle from '@/routes_new/inner/vacancy/components/vtitle';

  export default {
    name: 'VacancyHackerrank',

    components: {
      VacancyTitle
    },

    data() {
      return {
        switcherLoading: true,
        testsCount: 1,
        selectedTests: []
      };
    },

    computed: {
      ...mapState('vacancy_new', { vcvVacancyId: state => state.item.id }),

      ...mapState('integrationsHackerrank', ['isConnectionLoading', 'connectedVacancies']),

      ...mapGetters('integrationsHackerrank', [
        'isVacancyHackerrankConnected',
        'getHackerrankTestsForSelect'
      ]),

      selectedTestsForSave() {
        return this.selectedTests.map(x => {
          return { id: x.id };
        });
      },

      optionsForSelect() {
        return differenceBy(this.getHackerrankTestsForSelect, this.selectedTests, 'id');
      }
    },

    async created() {
      await this.checkExistingConnection(Number(this.vcvVacancyId));
      await this.fetchHackerrankTests();

      this.setTestsFromStore();
    },

    methods: {
      ...mapActions('integrationsHackerrank', [
        'checkExistingConnection',
        'toggleHackerrankToVacancy',
        'fetchHackerrankTests',
        'saveHackerrankTests'
      ]),

      setTestsFromStore() {
        if (
          this.connectedVacancies[0]._embedded !== undefined &&
          this.connectedVacancies[0]._embedded.tests !== undefined
        ) {
          this.selectedTests = this.connectedVacancies[0]._embedded.tests.map(x => {
            return { id: x.id, name: x.title };
          });
          this.testsCount = this.selectedTests.length;
        }
      },

      removeItemFromTests(index) {
        this.selectedTests.splice(index, 1);
        this.testsCount = this.selectedTests.length;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .hackerrank {
    margin-bottom: 200px;

    &__header {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    &__description {
      margin-bottom: 20px;
    }

    &__switcher {
      margin-bottom: 20px;
    }

    &__tests {
      margin: 20px 0;
    }

    &__test {
      border-top: 1px solid #eee;
      padding: 15px 0 20px;
    }

    &__test-header {
      font-size: 20px;
      margin-bottom: 15px;
    }

    &__test-select-wrapper {
      display: flex;
      justify-content: space-between;
    }

    &__test-select {
      width: 100%;
      max-width: none;
      margin-right: 10px;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>
